import { SPACING_1, Text } from '@mnd-frontend/ui';
import type React from 'react';
import styled, { css } from 'styled-components';

type Props = {
  disabled?: boolean;
  icon: React.ReactNode;
  caption: string;
};

const IconWrapper = styled.div<{ $disabled?: boolean }>`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  pointer-events: none;
  position: absolute;
  top: 0;

  p {
    margin-top: ${SPACING_1};
    max-width: 50%;
    word-break: break-word;
    text-align: center;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      p,
      svg {
        opacity: 0.7;
      }
      pointer-events: none;
    `}
`;

const IconAndCaption: React.FC<Props> = ({ icon, caption, disabled }) => (
  <IconWrapper $disabled={disabled}>
    {icon}
    <Text as="p" variant="body">
      {caption}
    </Text>
  </IconWrapper>
);

export default IconAndCaption;
